// Ertan Kasap - statik ön yüz sabitleri

export const LOGO_URL = "/logo.webp";

export const QUANTITY_OPTIONS = ["250 gr", "500 gr", "750 gr", "1 kg", "1.5 kg", "2 kg"];

// Ürün durumu (admin yönetimli)
export const STATUS_META = {
  available: { label: "Bugün Mevcut", dot: "#34D399", text: "text-emerald-300" },
  limited: { label: "Sınırlı Stok", dot: "#FBBF24", text: "text-amber-300" },
  preorder: { label: "Ön Sipariş", dot: "#F87171", text: "text-red-300" },
  out: { label: "Şu Anda Yok", dot: "#9CA3AF", text: "text-neutral-400" },
};

export const NAV_LINKS = [
  { to: "/", label: "Ana Sayfa" },
  { to: "/urunler", label: "Ürünler" },
  { to: "/market", label: "Market" },
  { to: "/paketler", label: "Paketler" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/iletisim", label: "İletişim" },
];

// Market ürünleri adet bazlı satılır (kasaplık kg bazlı QUANTITY_OPTIONS'tan farklı).
export const ADET_OPTIONS = ["1 adet", "2 adet", "3 adet", "4 adet", "5 adet", "6 adet", "8 adet", "10 adet"];

// --- Kontrollü sipariş akışı: teslimat bölgeleri, teslimat zamanı, ödeme ------
// Hizmet verilen semtler (Beşiktaş – Gayrettepe çevresi). Admin ileride düzenleyebilir.
export const SERVICE_AREAS = [
  "Gayrettepe", "Esentepe", "Balmumcu", "Dikilitaş", "Fulya",
  "Levent", "1. Levent", "Etiler", "Bebek", "Arnavutköy",
  "Ortaköy", "Kuruçeşme", "Beşiktaş Merkez (Sinanpaşa)", "Abbasağa",
  "Türkali", "Muradiye", "Vişnezade", "Nişantaşı", "Teşvikiye", "Mecidiyeköy",
];

export const DELIVERY_TIME_OPTIONS = [
  "En kısa sürede",
  "Bugün – gün içinde",
  "Yarın – gün içinde",
];

export const PICKUP_DISCOUNT_PCT = 20;     // Dükkândan Al indirimi
export const DELIVERY_MIN_TOTAL = 600;     // Adrese teslim minimum sepet (TL)

// Sepet toplamını teslimat türüne göre hesaplar (pickup'ta %20 indirim).
export function computeTotals(subtotal, fulfillment) {
  const sub = Math.round(subtotal || 0);
  if (fulfillment === "pickup" && sub > 0) {
    const discountAmount = Math.round((sub * PICKUP_DISCOUNT_PCT) / 100);
    return { subtotal: sub, discountPct: PICKUP_DISCOUNT_PCT, discountAmount, total: sub - discountAmount };
  }
  return { subtotal: sub, discountPct: 0, discountAmount: 0, total: sub };
}

export const PAYMENT_OPTIONS = [
  { key: "cash", label: "Kapıda Nakit" },
  { key: "card", label: "Kapıda Kredi Kartı (POS)" },
];

export const PAYMENT_LABEL = { cash: "Kapıda Nakit", card: "Kapıda Kredi Kartı" };
export const FULFILLMENT_LABEL = { delivery: "Adrese Teslim", pickup: "Dükkândan Teslim Al" };


// Ana sayfa "Bugün Ne Pişireceksiniz?"
export const HOME_COOK_OPTIONS = [
  { key: "Mangal", label: "Mangal", icon: "Flame" },
  { key: "Tava", label: "Tava", icon: "CookingPot" },
  { key: "Fırın", label: "Fırın", icon: "Microwave" },
  { key: "Tencere", label: "Tencere", icon: "Soup" },
  { key: "Burger", label: "Burger", icon: "Sandwich" },
  { key: "Özel Akşam Yemeği", label: "Özel Akşam", icon: "UtensilsCrossed" },
];

// Akıllı Rehber adımları
export const GUIDE_STEP_METHODS = ["Mangal", "Tava", "Fırın", "Tencere", "Burger", "Haşlama"];
export const GUIDE_STEP_NEEDS = [
  "Yumuşak et",
  "Yoğun lezzet",
  "Ekonomik tercih",
  "Premium deneyim",
  "Kalabalık sofra",
  "Çocuklar için uygun",
];
export const GUIDE_STEP_EXPERIENCE = [
  "İlk kez yapıyorum",
  "Biraz tecrübeliyim",
  "Usta işi istiyorum",
];

export const METHOD_ICON = {
  Mangal: "Flame",
  Tava: "CookingPot",
  Fırın: "Microwave",
  Tencere: "Soup",
  Burger: "Sandwich",
  Haşlama: "Soup",
};

export const TAG_STYLES = {
  "Mangal Favorisi": "bg-[#EA580C]/15 text-[#FDBA74] border-[#EA580C]/40",
  "Şef Önerisi": "bg-[#D97706]/15 text-[#FCD34D] border-[#D97706]/40",
  Premium: "bg-[#B45309]/15 text-[#E8A15E] border-[#B45309]/50",
  "Aile İçin": "bg-[#059669]/15 text-[#6EE7B7] border-[#059669]/40",
  "Çok Satan": "bg-[#7A1A1A]/20 text-[#E8A15E] border-[#7A1A1A]/50",
  "Bugün Taze Kesim": "bg-[#C57B43]/15 text-[#E8A15E] border-[#C57B43]/40",
};

export const DIFFICULTY_STYLES = {
  Kolay: "text-emerald-400",
  Orta: "text-amber-400",
  "Usta işi": "text-[#E8A15E]",
};

export const FAT_LABEL = { Az: "Az", Orta: "Orta", Yüksek: "Yüksek" };

export const EDITORIAL = {
  hero: "/products/scene-hero.webp",
  butcher: "/products/scene-butcher.webp",
  fire: "/products/scene-fire.webp",
  charcuterie: "/products/scene-charcuterie.webp",
};

// Fiyat biçimlendirme — Türkçe binlik ayraç + ₺
export const formatPrice = (v) =>
  v == null || v === "" ? null : `${Number(v).toLocaleString("tr-TR")} ₺`;

// "1 kg" / "500 gr" / "1.5 kg" → kg cinsinden sayı (özel/parse edilemeyen → null)
export const parseQuantityKg = (q) => {
  if (q == null) return null;
  const s = String(q).toLowerCase().replace(",", ".");
  const m = s.match(/([\d.]+)\s*(kg|gr|g)?/);
  if (!m) return null;
  const n = parseFloat(m[1]);
  if (Number.isNaN(n)) return null;
  const unit = m[2];
  if (unit === "gr" || unit === "g") return n / 1000;
  return n; // kg ya da çıplak sayı → kg kabul edilir
};

// Bir sipariş kalemi için tahmini tutar (kg ürünlerde fiyat×kg, adet/paket ürünlerde fiyat×adet)
export const lineEstimate = (item) => {
  if (!item || item.price == null) return null;
  const unit = item.unit || "kg";
  if (unit === "kg") {
    const kg = parseQuantityKg(item.quantity);
    return kg != null ? item.price * kg : null;
  }
  const n = parseFloat(String(item.quantity)) || 1;
  return item.price * n;
};
